import BaseApi from '../BaseApi';

export type TTypeStatusAPI =
  | 'Approve'
  | 'ApproveDebtOrder'
  | 'ApproveDiscountOrder'
  | 'Assign'
  | 'Accept'
  | 'AcceptV2'
  | 'Reject'
  | 'Start'
  | 'StartV2'
  | 'Finish'
  | 'Complete'
  | 'Pending'
  | 'Reprocess'
  | 'Cancel'
  | 'CancelDebtOrder'
  | 'FinishRepair' // bổ sung các type khác..
  | 'FinishRepairV2' // bổ sung các type khác..
  | 'CompleteRepair'
  | 'FinishUpgrade'
  | 'FinishUpgradeV2'
  | 'CompleteUpgrade'
  | 'CompleteChangeCompany'
  | 'CSCallToCustomer'
  | 'OperatorChangePriority'
  | 'KyThuatChangeSummaryDonHangGui'
  | 'UpdateReturnOrderAfterComplete'
  | 'UpdateDiffOrder'
  | 'PauseRequest' // Kỹ thuật tạm hoãn đơn
  | 'PauseRequestV2' // Kỹ thuật tạm hoãn đơn
  | 'ApprovePauseRequest'
  | 'ApprovePauseRequestV2'
  | 'ApproveAllPauseRequestV2'
  | 'Resume'
  | 'ResumeV2'
  | '';

/** GLD đơn gửi | lắp mới | thu đổi
 * SB đơn sửa chữa | bảo hành
 * NC đơn nâng cấp
 * TP đơn thu phí . thêm sau
 * TH đơn tháo . thêm sau
 * DLL đơn Đại lý lắp dùm
 */
export type TOrder = 'GLD' | 'SB' | 'NC' | 'TP' | 'TH' | 'DLL' | 'TN' | 'THang' | 'ChenhLech' | 'ChietKhau';

/* ---------- Maps cấu hình ---------- */

const CREATE_ENDPOINTS: Record<TOrder, string> = {
  GLD: 'Create',
  SB: 'CreateRepairV2',
  NC: 'CreateUpgradeV2',
  TP: 'CreateCollectFee',
  TH: 'CreateOrderThaolapLai',
  DLL: 'CreateOrderDaiLyLapGium',
  TN: 'CreateDebtOrder',
  THang: 'CreateReturnOrder',
  ChenhLech: 'CreateDiffOrder',
  ChietKhau: 'CreateDiscountOrder'
};

// [method, endpoint]
const UPDATE_ENDPOINTS: Record<TOrder, ['PUT' | 'POST', string]> = {
  GLD: ['PUT', 'Update'],
  SB: ['PUT', 'UpdateRepair'],
  NC: ['PUT', 'UpdateUpgradeV2'],
  TP: ['PUT', 'UpdateCollectFee'],
  TH: ['PUT', 'UpdateOrderThaoLapLai'],
  DLL: ['PUT', 'UpdateOrderDaiLyLapGium'],
  TN: ['PUT', 'UpdateDebtOrder'],
  THang: ['POST', 'UpdateReturnOrder'], // lưu ý: POST chứ không phải PUT
  ChenhLech: ['PUT', 'UpdateDiffOrder'],
  ChietKhau: ['POST', 'UpdateDiscountOrder']
};

const DETAIL_ENDPOINTS: Record<number, string> = {
  1: 'GetDetailsOrderGui',
  2: 'GetDetailsOrderLapMoi',
  3: 'GetDetailsOrderThuPhi',
  4: 'GetDetailsOrderSuaChua',
  5: 'GetDetailsOrderBaoHanh',
  6: 'GetDetailsOrderThuDoi',
  7: 'GetDetailsOrderNangCapV2',
  8: 'GetDetailsOrderThaoLapLai',
  9: 'GetDetailsOrderLapMoi',
  10: 'GetDetailsOrderLapMoi',
  11: 'GetDetailsOrderThuNo',
  12: 'GetDetailsOrderTraHang',
  13: 'GetDetailsOrderChenhLech',
  14: '',
  15: 'GetDetailsOrderChietKhau'
};

const ACTION_POST_TYPES = new Set<TTypeStatusAPI>([
  'UpdateReturnOrderAfterComplete',
  'ApproveDebtOrder',
  'UpdateDiffOrder',
  'ApproveDiscountOrder'
]);

const qs = (params: Record<string, any>) =>
  new URLSearchParams(Object.entries(params).map(([k, v]) => [k, String(v)])).toString();

// export type TFullOrder = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9; // định dùng cho api GetDetailOfOrder nhưng giờ thì thôi k cần nữa
const OrderManagerApi = {
  // lấy loại đơn hàng
  GetAllTypeOrders: () => {
    return BaseApi.GET('api/Order/AllOrderType');
  },
  GetDetailDebtCustomer: (data: any) => {
    return BaseApi.POST('api/Report/GetDetailDebtCustomer', data);
  },
  BaoCaoDoanhThu: (data: any) => {
    return BaseApi.POST('api/Report/BaoCaoDoanhThu', data);
  },
  BaoCaoDoanhThuV2: (data: any) => {
    return BaseApi.POST('api/Report/BaoCaoDoanhThuV2', data);
  },
  BaoCaoDoanhThuV3: (data: any) => {
    return BaseApi.POST('api/Report/BaoCaoDoanhThuV3', data);
  },
  DetailTheoKhachHang: (data: any) => {
    return BaseApi.POST('api/Report/DetailTheoKhachHang', data);
  },
  SnapshotDebt: (data: any) => {
    return BaseApi.POST('api/ClosingMonth/SnapshotDebt', data);
  },
  GetOrderReportV5: (data: any) => {
    return BaseApi.POST('api/Report/GetOrderReportV5', data);
  },
  GetOrderReportPaging: (data: any) => {
    return BaseApi.POST('api/Report/GetOrderReportPaging', data);
  },
  GetOrderReportKyThuatPaging: (data: any) => {
    return BaseApi.POST('api/Report/GetBaoCaoChiTietKyThuatPaging', data);
  },
  BaoCaoDoanhThuTheoKinhDoanh: (data: any) => {
    return BaseApi.POST('api/Report/BaoCaoDoanhThuTheoKinhDoanh', data);
  },
  BaoCaoChiTietDoanhThuTheoKinhDoanh: (data: any) => {
    return BaseApi.POST('api/Report/BaoCaoChiTietDoanhThuTheoKinhDoanh', data);
  },
  BaoCaoKhoKyThuatPaging: (data: any) => {
    return BaseApi.POST('api/Report/BaoCaoKhoKyThuatPaging', data);
  },
  // check trùng bs
  CheckTrungBS: (data: any) => {
    return BaseApi.POST('api/Order/CheckTrungBienSo', data);
  },
  GetEligibleInDebtOrders: (data: any) => {
    return BaseApi.POST('api/Order/GetEligibleInDebtOrders', data);
  },
  LayDanhSachDonNo: (data: any) => {
    return BaseApi.POST('api/Order/LayDanhSachDonNo', data);
  },
  // Các phân bổ (trả một phần từ đơn thu nợ) vào những đơn này. Body: ['261028006', ...]
  GetAllocationsByOrderCode: (orderCodes: string[]) => {
    return BaseApi.POST('api/Order/GetAllocationsByOrderCode', orderCodes);
  },
  // tạo đơn hàng !!
  CreateNewOrder: (data: any, typeOrder: TOrder) => BaseApi.POST(`api/Order/${CREATE_ENDPOINTS[typeOrder]}`, data),

  UpdateOrder: (data: any, typeOrder: TOrder) => {
    const [method, endpoint] = UPDATE_ENDPOINTS[typeOrder];
    return BaseApi[method](`api/Order/${endpoint}`, data);
  },

  // CreateNewOrder: (data, typeOrder: TOrder) => {
  //   if (typeOrder == 'GLD') {
  //     return BaseApi.POST('api/Order/Create', data);
  //   }
  //   // if (typeOrder == 'SB') {
  //   //   return BaseApi.POST('api/Order/CreateRepair', data);
  //   // }
  //   if (typeOrder == 'SB') {
  //     return BaseApi.POST('api/Order/CreateRepairV2', data);
  //   }
  //   // if (typeOrder == 'NC') {
  //   //   return BaseApi.POST('api/Order/CreateUpgrade', data);
  //   // }
  //   if (typeOrder == 'NC') {
  //     return BaseApi.POST('api/Order/CreateUpgradeV2', data);
  //   }
  //   if (typeOrder == 'TP') {
  //     return BaseApi.POST('api/Order/CreateCollectFee', data);
  //   }
  //   if (typeOrder == 'TH') {
  //     return BaseApi.POST('api/Order/CreateOrderThaolapLai', data);
  //   }
  //   if (typeOrder == 'DLL') {
  //     return BaseApi.POST('api/Order/CreateOrderDaiLyLapGium', data);
  //   }
  //   if (typeOrder == 'TN') {
  //     return BaseApi.POST('api/Order/CreateDebtOrder', data);
  //   }
  //   if (typeOrder == 'THang') {
  //     return BaseApi.POST('api/Order/CreateReturnOrder', data);
  //   }
  //   if (typeOrder == 'ChenhLech') {
  //     return BaseApi.POST('api/Order/CreateDiffOrder', data);
  //   }
  // },
  // // cập nhật đơn hàng !!
  // UpdateOrder: (data, typeOrder: TOrder) => {
  //   if (typeOrder == 'GLD') {
  //     return BaseApi.PUT('api/Order/Update', data);
  //   }
  //   if (typeOrder == 'SB') {
  //     return BaseApi.PUT('api/Order/UpdateRepair', data);
  //   }
  //   // if (typeOrder == 'NC') {
  //   //   return BaseApi.PUT('api/Order/UpdateUpgrade', data);
  //   // }
  //   if (typeOrder == 'NC') {
  //     return BaseApi.PUT('api/Order/UpdateUpgradeV2', data);
  //   }
  //   if (typeOrder == 'TP') {
  //     return BaseApi.PUT('api/Order/UpdateCollectFee', data);
  //   }
  //   if (typeOrder == 'TH') {
  //     return BaseApi.PUT('api/Order/UpdateOrderThaoLapLai', data);
  //   }
  //   if (typeOrder == 'DLL') {
  //     return BaseApi.PUT('api/Order/UpdateOrderDaiLyLapGium', data);
  //   }
  //   if (typeOrder == 'TN') {
  //     return BaseApi.PUT('api/Order/UpdateDebtOrder', data);
  //   }
  //   if (typeOrder == 'THang') {
  //     return BaseApi.POST('api/Order/UpdateReturnOrder', data);
  //   }
  // },

  // Cập nhật hình ảnh của đơn hàng
  UploadImageOrder: (data: any) => {
    return BaseApi.PUT('api/Order/UploadImageOrder', data);
  },
  // Cập nhật tiền thực thu do kto làm
  UpdatePayment: (data: any) => {
    return BaseApi.PUT('api/Order/UpdatePayment', data);
  },
  // Các thao tác của các nv đến đơn hàng
  // ActionStatusOrder: (type: TTypeStatusAPI, data?: any) => {
  //   if (type === 'UpdateReturnOrderAfterComplete') {
  //     return BaseApi.POST(`api/Order/${type}`, data);
  //   } else if (type === 'ApproveDebtOrder') {
  //     return BaseApi.POST(`api/Order/${type}`, data);
  //   } else if (type === 'UpdateDiffOrder') {
  //     return BaseApi.POST(`api/Order/${type}`, data);
  //   } else if (type === 'PauseRequestV2') {
  //     return BaseApi.PUT(`api/Order/${type}`, data);
  //   } else if (type === 'ApprovePauseRequestV2') {
  //     return BaseApi.PUT(`api/Order/${type}`, data);
  //   } else if (type === 'ApproveAllPauseRequestV2') {
  //     return BaseApi.PUT(`api/Order/${type}?maDonHang=${data.maDonHang}&isApproved=${data.isApproved}`, undefined);
  //   } else if (type === 'ResumeV2') {
  //     return BaseApi.PUT(`api/Order/${type}?maDonHang=${data}`, undefined);
  //   } else {
  //     return BaseApi.PUT(`api/Order/${type}`, data);
  //   }
  // },

  ActionStatusOrder: (type: TTypeStatusAPI, data?: any) => {
    switch (type) {
      case 'ApproveAllPauseRequestV2':
        return BaseApi.PUT(
          `api/Order/${type}?${qs({ maDonHang: data.maDonHang, isApproved: data.isApproved })}`,
          undefined
        );
      case 'ResumeV2':
        return BaseApi.PUT(`api/Order/${type}?${qs({ maDonHang: data })}`, undefined);
      case 'ApprovePauseRequest':
        return BaseApi.PUT(
          `api/Order/${type}?${qs({ maDonHang: data.maDonHang, isApproved: data.isApprove })}`,
          undefined
        );
      case 'Resume':
        return BaseApi.PUT(`api/Order/${type}?${qs({ maDonHang: data })}`, undefined);
      default:
        return ACTION_POST_TYPES.has(type)
          ? BaseApi.POST(`api/Order/${type}`, data)
          : BaseApi.PUT(`api/Order/${type}`, data);
    }
  },
  RequestOrder: (type?: any, maDonHang?: any) => {
    return BaseApi.PUT(`api/Order/${type}?maDonHang=${maDonHang}`, undefined);
  },
  // Lấy chi tiết từng loại đơn hàng
  GetDetailOfOrder: (codeOrder: string, typeOrder: number | string) => {
    const endpoint = DETAIL_ENDPOINTS[Number(typeOrder)];
    if (!endpoint) return undefined;
    return BaseApi.GET(`api/Order/${endpoint}?${qs({ madonhang: codeOrder })}`);
  },
  // GetDetailOfOrder: (codeOrder: string, typeOrder: number | string) => {
  //   if (typeOrder === 1) {
  //     return BaseApi.GET(`api/Order/GetDetailsOrderGui?madonhang=${codeOrder}`);
  //   }
  //   if (typeOrder === 2 || typeOrder === 9 || typeOrder === 10) {
  //     return BaseApi.GET(`api/Order/GetDetailsOrderLapMoi?madonhang=${codeOrder}`);
  //   }
  //   if (typeOrder === 3) {
  //     return BaseApi.GET(`api/Order/GetDetailsOrderThuPhi?madonhang=${codeOrder}`);
  //   }
  //   if (typeOrder === 4) {
  //     return BaseApi.GET(`api/Order/GetDetailsOrderSuaChua?madonhang=${codeOrder}`);
  //   }
  //   if (typeOrder === 5) {
  //     return BaseApi.GET(`api/Order/GetDetailsOrderBaoHanh?madonhang=${codeOrder}`);
  //   }
  //   if (typeOrder === 6) {
  //     return BaseApi.GET(`api/Order/GetDetailsOrderThuDoi?madonhang=${codeOrder}`);
  //   }
  //   // if (typeOrder === 7) {
  //   //   return BaseApi.GET(`api/Order/GetDetailsOrderNangCap?madonhang=${codeOrder}`);
  //   // }
  //   if (typeOrder === 7) {
  //     return BaseApi.GET(`api/Order/GetDetailsOrderNangCapV2?madonhang=${codeOrder}`);
  //   }
  //   if (typeOrder === 8) {
  //     return BaseApi.GET(`api/Order/GetDetailsOrderThaoLapLai?madonhang=${codeOrder}`);
  //   }
  //   if (typeOrder === 11) {
  //     return BaseApi.GET(`api/Order/GetDetailsOrderThuNo?madonhang=${codeOrder}`);
  //   }
  //   if (typeOrder === 12) {
  //     return BaseApi.GET(`api/Order/GetDetailsOrderTraHang?madonhang=${codeOrder}`);
  //   }
  //   if (typeOrder === 13) {
  //     return BaseApi.GET(`api/Order/GetDetailsOrderChenhLech?madonhang=${codeOrder}`);
  //   }
  // },
  // tìm kiếm đơn hàng theo Mã đơn Tên - SĐT khách hàng.
  SearchOrderByText: (searchText: any, searchWhat?: any) => {
    return BaseApi.GET(
      `api/Order/Search?input=${searchText}&searchWhat=${searchWhat === 0 ? 0 : searchWhat || 1}`,
      null,
      25000 // Quá 25s sẽ hủy gọi API
    );
  },
  // Tìm kiếm theo kiểm mới cho báo cáo đơn hàng
  SearchOrderV2: (data: any, input: any, searchWhat: any) => {
    return BaseApi.POST(
      `api/Order/SearchV2?input=${input}&searchWhat=${searchWhat === 0 ? 0 : searchWhat || 1}`,
      data,
      null,
      25000 // Quá 25s sẽ hủy gọi API
    );
  },
  ThonekeSim: (data: any) => {
    return BaseApi.POST(
      'api/Report/ThongKeSim',
      data,
      null,
      25000 // Quá 25s sẽ hủy gọi API
    );
  },
  SendOperatorSeen: (codeOrder: string) => {
    return BaseApi.PUT(`api/Order/OperatorSeen?maDonHang=${codeOrder}`, undefined);
  },
  // Snapshot dữ liệu đơn hàng tại thời điểm TRƯỚC khi bị backdoor (mở lại) - dùng để đối chứng với dữ liệu hiện tại
  GetBackDoorSnapshot: (maDonHang: string) => {
    return BaseApi.GET(`api/Order/GetBackDoorSnapshot?${qs({ maDonHang })}`);
  }
};

export default OrderManagerApi;
